import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col overflow-hidden bg-background-50">
      {/* 大面积柔和装饰光晕 */}
      <div className="absolute -top-32 -left-40 w-[600px] h-[600px] md:w-[800px] md:h-[800px] rounded-full bg-primary-200/25 blur-[120px] pointer-events-none" />
      <div className="absolute top-1/3 -right-32 w-[500px] h-[500px] md:w-[700px] md:h-[700px] rounded-full bg-accent-100/35 blur-[100px] pointer-events-none" />
      <div className="absolute bottom-20 left-1/3 w-[400px] h-[400px] rounded-full bg-secondary-200/30 blur-[90px] pointer-events-none" />

      <div className="flex-1 flex flex-col lg:flex-row items-center pt-24 pb-8 px-4 md:px-6 w-full max-w-7xl mx-auto relative z-10">
        <div className="lg:w-3/5 mt-8 lg:mt-0">
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-heading font-bold text-foreground-900 leading-none tracking-tight">
            Pandabuy<br />
            <span className="text-primary-500">Spreadsheet</span><br />
            <span className="text-foreground-600 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal italic">Curated Finds</span>
          </h1>
          <p className="mt-6 text-sm md:text-base text-foreground-500 max-w-lg">
            Your trusted SEO hub for the most updated pandabuyspreadsheet collections. Verified product links, trending hauls, and curated categories — all in one place.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Explore Full Database &rarr;
            </a>
            <Link
              to="/blog/pandabuy-spreadsheet-ultimate-guide-2026"
              className="px-6 py-3 rounded-full border border-foreground-300 text-sm text-foreground-700 hover:border-foreground-500 hover:text-foreground-900 transition-all whitespace-nowrap cursor-pointer bg-background-50/60 backdrop-blur-sm"
            >
              Read Our Guide
            </Link>
          </div>
        </div>

        <div className="lg:w-2/5 mt-10 lg:mt-0 lg:pl-12 relative">
          <div className="absolute -top-8 -right-8 w-32 h-32 rounded-full bg-primary-100/50 blur-2xl pointer-events-none" />
          <p className="text-sm text-foreground-500 leading-relaxed relative z-10">
            Discover thousands of verified pandabuy spreadsheet finds across shoes, clothing, accessories, and more. Updated weekly with fresh links and quality scores to help you build the perfect haul.
          </p>
          <div className="mt-8 flex items-center gap-8 relative z-10">
            <div>
              <span className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">500+</span>
              <p className="text-xs text-foreground-500 mt-1">Verified Finds</p>
            </div>
            <div>
              <span className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">1000+</span>
              <p className="text-xs text-foreground-500 mt-1">Active Links</p>
            </div>
          </div>
          <div className="mt-8 flex items-center gap-3 flex-wrap relative z-10">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium">
              <i className="ri-check-line text-sm w-4 h-4 flex items-center justify-center"></i>
              Updated Weekly
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium">
              <i className="ri-shield-check-line text-sm w-4 h-4 flex items-center justify-center"></i>
              Verified Finds
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium">
              <i className="ri-group-line text-sm w-4 h-4 flex items-center justify-center"></i>
              Community Curated
            </span>
          </div>
        </div>
      </div>

      <div className="w-full h-[40vh] md:h-[50vh] relative mt-8">
        <img
          src="https://readdy.ai/api/search-image?query=High-end%20streetwear%20collection%20flat%20lay%20with%20designer%20sneakers%20premium%20hoodies%20and%20luxury%20accessories%20arranged%20on%20warm%20marble%20surface%20editorial%20fashion%20photography%20soft%20golden%20lighting%20warm%20beige%20tones%20clean%20minimalist%20composition%20high%20detail%20product%20showcase&width=1800&height=900&seq=hero-streetwear-v2-2026&orientation=landscape"
          alt="Trendy streetwear sneakers and fashion clothing flat lay arrangement"
          title="Pandabuy spreadsheet fashion finds"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50 via-transparent to-background-100"></div>
      </div>
    </section>
  );
}